import { getWithoutNilQuery } from '@/utils/path';
import { useRouter } from '@/router/useRouter';
import { aiProjectEditorRouteName } from '@/router/route-const';
export function openAiProjectEditor(query = {}, newWindow = false) {
    const { router, route } = useRouter();
    const projectId = query.projectid || route.value?.query?.projectid;
    const routeQuery = getWithoutNilQuery({
        ...query,
        projectid: projectId,
        branch: query.branch || route.value?.query?.branch,
    });
    const url = router.value?.resolve({ name: aiProjectEditorRouteName, query: routeQuery })?.href;
    if (newWindow) {
        window.open(url, '_blank', 'noopener=yes');
    }
    else {
        window.location.href = url;
    }
}
/**
 * 打开AI编辑器并删除页面文件
 */
export function openAiProjectEditorToDeletePage(options, newWindow = false) {
    const { projectid, pageId } = options;
    const fileName = pageId === 'aipage' ? 'index' : pageId.replace(/^aipage-/, '');
    openAiProjectEditor({
        projectid,
        prompt: `删除文件 /pages/${fileName}.vue`,
    }, newWindow);
}
